import Box from "@mui/material/Box";
import UserListContainer from "./user-list";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../common/ErrorFallback";
import { Route, Routes } from "react-router";

function UserContainer() {
  return (
    <Box
      data-testid="user-container"
      sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Routes>
          <Route path="/*" element={<UserListContainer />} />
        </Routes>
      </ErrorBoundary>
    </Box>
  );
}

export default UserContainer;
